import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { CRASH_LOGS_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { CRASH_LOGS_REPORT } from "../interfaces/dashboard";

export default function CrashLogs() {
    const crashLogsReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.CRASH_LOGS_REPORT;

    const [crashLogsReportTableData, setCrashLogsReportTableData] = useState<CRASH_LOGS_REPORT[]>([]);

    useEffect(() => {
        setCrashLogsReportTableData(CRASH_LOGS_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="CRASH_LOGS"
        tableColumns={crashLogsReportTableColumns}
        tableData={crashLogsReportTableData} />
    );
}